jQuery(function ($) {
  $(".testimonial-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  let isMobile = window.innerWidth < 768;

  const $heroSection = $(".hero");
  const $footerSection = $("footer");

  const toggleSticky = (toggle, mobile) => {
    if (toggle) {
      if (mobile) {
        toggleSticky(false, false);
        $(".section-footer").addClass("sticky");
        $footerSection.css("marginBottom", $(".section-footer").height());
      } else {
        toggleSticky(false, true);
        $(".header").addClass("sticky");
        $heroSection.css("marginTop", $(".header").height());
      }
    } else {
      if (mobile) {
        $(".section-footer").removeClass("sticky");
        $footerSection.css("marginBottom", 0);
      } else {
        $(".header").removeClass("sticky");
        $heroSection.css("marginTop", 0);
      }
    }
  };

  const targetOffset = jQuery(".section.section-features").offset().top;

  const handleScroll = () => {
    const scrollTop = $(window).scrollTop();
    if (scrollTop > targetOffset) {
      toggleSticky(true, isMobile);
    } else {
      toggleSticky(false, isMobile);
    }
  };

  $(window).on("scroll", handleScroll);
  $(window).on("resize", () => {
    isMobile = window.innerWidth < 768;
    handleScroll(isMobile);
    if (window.innerWidth > 767) {
      $(".testimonial-slider").slick("slickGoTo", 0);
    }
  });
});
